import classNames from "classnames";
interface LeaderboardHeaderProps {
  className?: string;
  mainTitle: string;
  subTitle?: string;
}

export function LeaderboardHeader(props: LeaderboardHeaderProps) {
  const { className, mainTitle, subTitle } = props;

  return (
    <div className={classNames(className)}>
      <h1 className="font-barlow text-[36px] leading-[34px] font-semibold text-white">{mainTitle}</h1>
      {subTitle && <h2 className="mt-[12px] text-[18px] font-medium text-lavender-50">{subTitle}</h2>}
    </div>
  );
}
